import React, { useEffect, useState } from "react";
import { Iparams, ResponseFilter } from "../../../../types/Ma";
import { addToArray } from "../../../../utils";
import { getDataService } from "../../../../service/applicatif/back-end-service";
import { url } from "../../../../service/constant";
import store from "../../../../redux/store";

export default function useFavorites() {
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState<ResponseFilter>({
    country: [],
    softwareSolution: [],
    featuredSolution: [],
    targetedIndustry: [],
  });
  const [limitSolution, setLimitSolution] = useState(6);
  const [limitIndustry, setLimitIndustry] = useState(6);
  const [limitCountry, setLimitCountry] = useState(6);
  const [selectedSolution, setSelectedSolution] = useState<Array<number>>([]);
  const [selectedIndustry, setSelectedIndustry] = useState<Array<number>>([]);
  const [selectedCountry, setSelectedCountry] = useState<Array<number>>([]);

  const [loadingFilter, setLoadingFilter] = useState<boolean>(false);
  const [loadingFetch, setLoadingFetch] = useState<boolean>(false);
  const [announcing, setAnnouncing] = useState({
    data: [],
    pagination: {
      current: 0,
      first: 1,
      last: 0,
      next: 0,
      parPage: 10,
      previous: 0,
      totalItems: 0,
    },
  });
  const [paramsAnnounce, setParamsAnnounce] = useState<Iparams>({
    softwareSolution: [],
    featuredSolution: [],
    targetedIndustry: [],
    itemsPerPage: 10,
    page: 1,
    favorite: 1,
  });

  const getMaFilterFavoritePage = async () => {
    setLoadingFilter(true);
    try {
      const response = await getDataService(
        url.Ma.filterFavorite,
        {},
        store?.getState()?.userReducer?.token
      );

      if (response?.status === 200) {
        setFilteredData(response?.data);
      }
      setLoadingFilter(false);
    } catch (error) {}
    setLoadingFilter(false);
  };

  const getMaListeFavorite = async (params: any) => {
    setLoadingFetch(true);
    try {
      const response = await getDataService(
        url.Ma.getAnnounce,
        params,
        store?.getState()?.userReducer?.token
      );
      if (response?.status === 200) {
        setAnnouncing({
          data: response?.data?.data,
          pagination: response?.data?.pagination,
        });
      }
      setLoadingFetch(false);
    } catch (error) {}
    setLoadingFetch(false);
  };

  const dataSolution = [
    ...(filteredData?.softwareSolution || []),
    ...(filteredData?.featuredSolution || []),
  ];

  const handleSelect = (element: number) => {
    setSelectedSolution(addToArray(selectedSolution, element));
  };

  const handleSelectedIndustry = (element: number) => {
    setSelectedIndustry(addToArray(selectedIndustry, element));
  };

  const handleSeeSolution = (action: string) => {
    setLimitSolution(action === "0" ? dataSolution.length : 6);
  };

  const handleSeeIndustry = (action: string) => {
    setLimitIndustry(
      action === "0" ? filteredData?.targetedIndustry?.length || 0 : 6
    );
  };

  const handleSelectedCountry = (element: number) => {
    setSelectedCountry(addToArray(selectedCountry, element));
  };

  const handleSeeCountry = (action: string) => {
    setLimitCountry(action === "0" ? filteredData?.country?.length || 0 : 6);
  };

  useEffect(() => {
    getMaFilterFavoritePage();
  }, []);

  useEffect(() => {
    getMaListeFavorite(paramsAnnounce);
  }, []);

  const resetFilter = async () => {
    setSelectedSolution([]);
    setSelectedIndustry([]);
    const params = {
      featuredSolution: [],
      softwareSolution: [],
      targetedIndustry: [],
      country: [],
      itemsPerPage: 10,
      page: 1,
      search: undefined,
      favorite: 1,
    };
    setParamsAnnounce(params);
    getMaListeFavorite(params);
  };

  const lunchFilter = () => {
    const getIdFeatured =
      filteredData?.featuredSolution.map((el) => el.id) || [];
    const getIdSolution =
      filteredData?.softwareSolution.map((el) => el.id) || [];

    const makeFeatured = selectedSolution.filter((el) => {
      if (getIdFeatured.includes(el)) {
        return el;
      }
    });
    const makeSolution = selectedSolution.filter((el) => {
      if (getIdSolution.includes(el)) {
        return el;
      }
    });
    const params = {
      featuredSolution: makeFeatured,
      softwareSolution: makeSolution,
      targetedIndustry: selectedIndustry,
      country: selectedCountry,
      itemsPerPage: 10,
      page: 1,
      favorite: 1,
    };
    setParamsAnnounce(params);
    getMaListeFavorite({
      ...params,
      featuredSolution: JSON.stringify(makeFeatured),
      softwareSolution: JSON.stringify(makeSolution),
      targetedIndustry: JSON.stringify(selectedIndustry),
      country: JSON.stringify(selectedCountry),
    });
  };

  const handlePageClick = (data: any) => {
    const params = {
      ...paramsAnnounce,
      page: data,
    };
    setParamsAnnounce(params);
    getMaListeFavorite({
      ...params,
      featuredSolution: JSON.stringify(paramsAnnounce.featuredSolution),
      softwareSolution: JSON.stringify(paramsAnnounce.softwareSolution),
      targetedIndustry: JSON.stringify(paramsAnnounce.targetedIndustry),
      country: JSON.stringify(paramsAnnounce.country),
    });
  };

  const search = () => {
    const params = {
      ...paramsAnnounce,
      search: searchText,
    };
    setParamsAnnounce(params);
    getMaListeFavorite({
      ...params,
      featuredSolution: JSON.stringify(paramsAnnounce.featuredSolution),
      softwareSolution: JSON.stringify(paramsAnnounce.softwareSolution),
      targetedIndustry: JSON.stringify(paramsAnnounce.targetedIndustry),
      country: JSON.stringify(paramsAnnounce.country),
    });
  };

  return {
    dataSolution,
    filteredData,
    limitSolution,
    limitIndustry,
    selectedSolution,
    selectedIndustry,
    handleSelect,
    handleSelectedIndustry,
    handleSeeSolution,
    resetFilter,
    handleSeeIndustry,
    announcing: announcing?.data,
    pagination: announcing?.pagination,
    paramsAnnounce,
    lunchFilter,
    showLoading: loadingFetch || loadingFilter,
    handlePageClick,
    searchText,
    setSearchText,
    search,
    limitCountry,
    handleSelectedCountry,
    selectedCountry,
    handleSeeCountry,
  };
}
